<template>
  <Transition mode="out-in">
    <div id="loading-div">
      <div class="work-summary" v-show="visible">
          <div class="work-summary__title">
              <YearMonthForm
                      :minYear="minYear"
                      :defaultYear="year"
                      :defaultMonth="monthName"
                      @monthSelected="(selMonthName, selMonthNr) => { monthName = selMonthName; monthNr = selMonthNr; }"
                      @yearSelected="(selYear) => { year = selYear; }"
                      @modeSelected="(selMode) => { showDeclaredTime = selMode; }"
                      @placeSelected="(selPlace) => { showPlace = selPlace; }"
                      @archivedSelected="(selArchived) => { showArchived = selArchived; }"
              />
              <EmployeeFilter :fields="['area', 'project', 'company']"
                              @params="params => this.employeeParams = params"/>
          </div>
          <transition name="fade">
              <div v-if="visible" class="table-responsive">
                  <table v-if="showPlace" class="table horizontal-table">
                      <thead>
                      <tr>
                          <th scope="col">Pracownik</th>
                          <template v-for="place in places">
                              <th v-if="isPlaceToShow(place, columns[place.id])"
                                  :style="'background-color:'+getPlaceColor(place.id)">
                                  {{ place.name }}
                              </th>
                          </template>
                          <th>
                              <span>Razem</span>
                          </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="summary in summaries" :class="{archived: summary.is_archived}">
                          <td scope="row">
                              {{ summary.name }}
                          </td>
                          <template v-for="place in places">
                              <td v-if="isPlaceToShow(place, columns[place.id])"
                                  :style="'background-color:'+getPlaceColor(place.id, summary)">
                                      <span v-if="showDeclaredTime">
                                          {{ displayWorkTimeInDecimalHours(summary.report[place.id]) }} /
                                          {{ displayWorkTimeInDecimalHours(summary.planned[place.id]) }}
                                      </span>
                                  <span v-else v-bind:title="displayWorkTime(summary.report[place.id])">
                                          {{ displayWorkTimeInDecimalHours(summary.report[place.id]) }}
                                      </span>
                              </td>
                          </template>
                          <td :class="{'insufficient-month': showDeclaredTime &&
                                      summary.report_total < summary.planned_total}">
                                  <span v-if="showDeclaredTime">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }} /
                                      {{ displayWorkTimeInDecimalHours(summary.planned_total) }}
                                  </span>
                              <span v-else v-bind:title="displayWorkTime(summary.report_total)">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }}
                                  </span>
                          </td>
                      </tr>
                      <tr>
                          <td></td>
                          <template v-for="place in places">
                              <td v-if="isPlaceToShow(place, columns[place.id])"
                                  :style="'background-color:'+getPlaceColor(place.id)">
                                  {{ displayWorkTimeInDecimalHours(columns[place.id]) }}
                              </td>
                          </template>
                          <td></td>
                      </tr>
                      </tbody>
                  </table>
                  <table v-else-if="monthNr !== -1" class="table horizontal-table">
                      <thead>
                      <tr>
                          <th scope="col">Pracownik</th>
                          <th v-for="day in daysNo" :class="{weekend: weekend(year, monthNr, day)}">
                              {{ padWithZeroes(day) }}
                          </th>
                          <th>
                              <span>Razem</span>
                          </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="summary in summaries"
                          :class="{insufficient: insufficient(summary.report_total), archived: summary.is_archived}">
                          <td scope="row">
                              {{ summary.name }}
                          </td>
                          <td v-for="day in daysNo"
                              :class="{weekend: weekend(year, monthNr, day),
                                  'insufficient-day': insufficientDay(summary, day)}">
                              <template v-if="absence(day, summary.absences)">
                                      <span v-if="!summary.report[day]">
                                          U
                                      </span>
                                  <span v-else>
                                          {{ displayWorkTimeInDecimalHours(summary.report[day]) }} / U
                                      </span>
                              </template>
                              <template v-else-if="showDeclaredTime">
                                      <span v-if="summary.planned[day] || summary.report[day]">
                                          {{ displayWorkTimeInDecimalHours(summary.report[day]) }} /
                                          {{ displayWorkTimeInDecimalHours(summary.planned[day]) }}
                                      </span>
                                  <span v-else>
                                          {{ displayWorkTimeInDecimalHours(summary.report[day]) }}
                                      </span>
                              </template>
                              <template v-else>
                                      <span v-bind:title="displayWorkTime(summary.report[day])">
                                          {{ displayWorkTimeInDecimalHours(summary.report[day]) }}
                                      </span>
                              </template>
                          </td>
                          <td :class="{'insufficient-month': showDeclaredTime && !isFutureMonth() &&
                                      summary.report_total < summary.planned_total}">
                                  <span v-if="showDeclaredTime && (summary.planned_total || summary.report_total)">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }} /
                                      {{ displayWorkTimeInDecimalHours(summary.planned_total) }}
                                  </span>
                              <span v-else v-bind:title="displayWorkTime(summary.report_total)">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }}
                                  </span>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <table v-else class="table horizontal-table">
                      <thead>
                      <tr>
                          <th scope="col">Pracownik</th>
                          <th v-for="month in months" class="work-summary-month">
                              {{ month | capitalize }}
                          </th>
                          <th>Razem</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="summary in summaries" :class="{archived: summary.is_archived}">
                          <td scope="row">
                              {{ summary.name }}
                          </td>
                          <td v-for="month in monthsNo"
                              :class="{insufficient: insufficient(summary.report[month]),
                                          'insufficient-day': insufficientDay(summary, month),
                                           archived: summary.is_archived}">
                                    <span v-if="showDeclaredTime && (summary.planned[month] || summary.report[month])">
                                       {{ displayWorkTimeInDecimalHours(summary.report[month]) }} /
                                       {{ displayWorkTimeInDecimalHours(summary.planned[month]) }}
                                    </span>
                              <span v-else v-bind:title="displayWorkTime(summary.report[month])">
                                        {{ displayWorkTimeInDecimalHours(summary.report[month]) }}
                                    </span>
                          </td>
                          <td :class="{insufficient: insufficient(summary.report_total), 'insufficient-month':
                                      showDeclaredTime && summary.report_total < summary.planned_total,
                                       archived: summary.is_archived}">
                                  <span v-if="showDeclaredTime">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }} /
                                      {{ displayWorkTimeInDecimalHours(summary.planned_total) }}
                                  </span>
                              <span v-else v-bind:title="displayWorkTime(summary.report_total)">
                                      {{ displayWorkTimeInDecimalHours(summary.report_total) }}
                                  </span>
                          </td>
                      </tr>
                      </tbody>
                  </table>
              </div>
          </transition>
      </div>
    </div>
    </Transition>
</template>

<script>
    import {backend} from "../../backend";
    import Constants from '../../constants.js';
    import YearMonthForm from '../YearMonthForm.vue';
    import EmployeeFilter from './EmployeeFilter.vue';
    import Vuesax from "vuesax";
    import Vue from "vue";

    Vue.use(Vuesax);

    export default {
        name: "WorkSummary",
        components: {
            YearMonthForm,
            EmployeeFilter
        },
        data() {
            return {
                summaries: [],
                daysNo: moment().daysInMonth(),
                months: moment.localeData('pl').months(),
                monthNr: moment().month(),
                monthName: moment.localeData('pl').months()[moment().month()],
                monthsNo: moment.localeData('pl').months().length,
                year: moment().year(),
                minYear: Constants.get('WORK_SUMMARY_MIN_YEAR'),
                visible: false,
                showDeclaredTime: false,
                showArchived: false,
                employeeParams: {},
                showPlace: false,
                places: [],
                columns: [],
                placeColor: Constants.get('IA_PLACE_COLOR'),
            }
        },
        mounted() {
            this.loadSummaries();
            this.loadPlaces();
        },
        methods: {
            loadSummaries() {
                this.$vs.loading({container: '#loading-div', scale: 1})
                this.summaries = [];
                this.visible = false;

                let params = {
                    'year': this.year,
                };

                Object.assign(params, this.employeeParams);

                if (this.monthNr !== -1) {
                    params.month = this.monthNr + 1;
                }
                if (this.showPlace){
                    params.showPlace = this.showPlace;
                }
                if (this.showArchived) {
                    params.showArchived = this.showArchived;
                }
                backend.getSummaries(params)
                    .then((response) => {
                        this.summaries = this.prependUser(response.data);
                        if (this.showPlace) {
                            this.columns = response.data.columns;
                        }
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy pracowników', color: 'danger'});
                    })
                    .then(() => {
                        this.visible = true;
                        this.$vs.loading.close('#loading-div > .con-vs-loading')
                    });
            },
            loadPlaces() {
                backend.getPlaces(true)
                    .then((response) => {
                        this.places = response.data;
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy miejsc', color: 'danger'});
                    });
            },
            prependUser(data) {
                let remote_user_id = this.$store.getters['auth/remoteUser'];
                let user = data.rows[remote_user_id];
                data = Object.values(data.rows);
                data.sort((a, b) => {
                    return a['name'].localeCompare(b['name']);
                });
                let index = data.indexOf(user);
                if (index !== -1) {
                    data.splice(index, 1);
                    data.unshift(user);
                }
                return data;
            },
            padWithZeroes(number) {
                return number.toString().padStart(2, '0');
            },
            displayWorkTime(mins) {
                if (!mins) {
                    return '-';
                } else {
                    let hours = Math.floor(mins / 60);
                    let minutes = mins % 60;
                    return this.padWithZeroes(hours) + ':' + this.padWithZeroes(minutes);
                }
            },
            displayWorkTimeInDecimalHours(mins) {
                if (!mins) {
                    return '-';
                } else {
                    return (mins / 60).toFixed(2).replace(".", ",");
                }
            },
            weekend(year, month, day) {
                let weekday_nr = moment({year: year, month: month, day: day}).isoWeekday();
                return weekday_nr === 6 || weekday_nr === 7;
            },
            absence(day, absence_list) {
                return typeof absence_list !== "undefined" && typeof absence_list[this.monthNr] !== "undefined"
                    && absence_list[this.monthNr].indexOf(day) !== -1;
            },
            insufficient(work_time) {
                return !work_time || (Math.floor(work_time / 60) < Constants.get('WORK_SUMMARY_MIN_MONTH_WORK'));
            },
            insufficientDay(summary, day) {
                let reported_time = (summary.report && summary.report[day]) ? summary.report[day] : 0;
                let is_absent = this.absence(day, summary.absences);
                let planned_time = (summary.planned[day]) ? summary.planned[day] : 0;
                if (moment({year: this.year, month: this.monthNr, day: day}).isSameOrAfter(moment(), 'day')
                    && reported_time == 0)
                    return false;
                return (this.showDeclaredTime && !is_absent && planned_time > reported_time);
            },
            isFutureMonth() {
                return moment({year: this.year, month: this.monthNr, day: 1}).isAfter(moment(), 'month');
            },
            isPlaceToShow(place, sum) {
                return place.state_id == 1 || (place.state_id == 2 && sum > 0);
            },
            getPlaceColor: function (place, summary = undefined) {
                if (this.showDeclaredTime && summary) {
                    if (summary.planned[place] && summary.planned[place] > 0) {
                        if (!summary.report[place] || summary.report[place] < summary.planned[place]) {
                            return 'rgba(240, 200, 200, 0.85)';
                        }
                    }
                }
                return this.placeColor[place];
            },
        },
        watch: {
            employeeParams() {
                this.loadSummaries();
            },
            monthNr() {
                this.daysNo = moment({year: this.year, month: this.monthNr, day: 1}).daysInMonth();
                this.loadSummaries();
            },
            year() {
                this.loadSummaries();
            },
            showPlace() {
                this.loadSummaries();
            },
            showArchived() {
                this.loadSummaries();
            }
        },
        filters: {
            capitalize: function (value) {
                let string = value.toString();
                if (string !== "")
                    return string.charAt(0).toUpperCase() + string.slice(1);
                return string;
            }
        }
    }
</script>

<style lang="scss">
    .work-summary {
        .table {
            font-size: 0.7em;
        }

        tr:hover {
            background-color:#f5f5f5;
        }

        .work-summary__title {
            padding-left: 10px;

            select {
                width: 170px;
                display: inline;
            }

            .col-sm-6 {
                width: auto;
                display: inline-block;
                flex: none;
            }

            h3 {
                text-align: center;
            }

            .row {
                margin: 0;
            }
        }

        .horizontal-table {
            width: 100%;
            display: table;
        }

        table th.work-summary-month {
            width: auto;
            text-align: left;
        }

        .weekend {
            background-color: rgba(226, 221, 221, 0.49);
        }

        .insufficient-day {
            background-color: rgba(240, 200, 200, 0.85);
        }

        .insufficient-month {
            background-color: rgba(250, 90, 00, 0.45);
        }

        .insufficient {
            color: blue;
        }

        .archived {
            color: sienna;
        }
    }
</style>


// WEBPACK FOOTER //
// WorkSummary.vue?2e15554e